import { List } from 'immutable'
import React from 'react'
import { Updater, any, async, fromJSX, nothing } from 'widgets-for-react'
import { ViewListenerState } from '../viewListener/viewListenerState'
import { HeaderLayout } from './headerLayout'
import {
  HeaderItem,
  HeaderState,
  headerStateUpdaters,
  UtilityItem
} from './headerState'
import { translateStateUpdaters } from '../automaticTranslator/translateState'

export const headerWidget = (view: ViewListenerState) => (
  state: HeaderState
) => {
  const headerDataState = state.headerItemsState
  const utilityDataState = state.utilityItemsState

  return any<Updater<HeaderState>>([
    async<List<HeaderItem>>(state.headerItemsState).map(
      headerStateUpdaters.updateHeaderDataState
    ),
    async<List<UtilityItem>>(state.utilityItemsState).map(
      headerStateUpdaters.updateUtilityDataState
    ),
    headerDataState.kind === 'loaded' && utilityDataState.kind === 'loaded'
      ? fromJSX(setState => (
          <HeaderLayout
            items={headerDataState.value
              .map((item, index) => ({
                ...item,
                isItemOpen: item.opened,
                toggleItem: () =>
                  setState(headerStateUpdaters.updateItemOpened(index))
              }))
              .toArray()}
            utilityItems={utilityDataState.value.toArray()}
            view={view}
            isMenuOpen={state.menuOpened}
            toggleMenu={() => setState(headerStateUpdaters.updateMenuOpened)}
            translateState={state.translateState}
            toggleTranslateModal={(toggle: boolean) =>
              setState(translateStateUpdaters.toggleTranslateModal(toggle))
            }
            closeTranslateBanner={() =>
              setState(translateStateUpdaters.closeTranslateBanner())
            }
            updateSelectedLanguage={() =>
              setState(translateStateUpdaters.updateTranslateStateOnLanguageSelect())
            }
          />
        ))
      : nothing()
  ])
}
